import { ApiService } from '../../../types/api';
import type { CustomerGroupApiResponse } from '../types/customer-group-response';
import { CustomerGroupApi, type CustomerGroupApiContract } from './customer-group.api';

export interface CustomerGroupsApiContract {
  list(): Promise<CustomerGroupApiResponse[]>;
  group(slug: string): CustomerGroupApiContract;
}

declare module '../../../context/page-context' {
  interface Apis {
    customerGroups: CustomerGroupsApiContract;
  }
}

export class CustomerGroupsApi extends ApiService implements CustomerGroupsApiContract {
  public list(): Promise<CustomerGroupApiResponse[]> {
    return this.api.proxy({
      method: 'GET',
      path: '/internal/v1/customer-group-settings',
    });
  }

  public group(slug: string): CustomerGroupApiContract {
    return new CustomerGroupApi(this.api, slug);
  }
}
